import React from 'react';
import { browserHistory } from 'react-router';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import PageHeader from '../PageHeader/PageHeader';
import './Change.scss';
import loader from '../../assets/loading.gif';
import DashboardConstants from '../myaccount/DashboardConstants';
import PlanUtilities from '../../services/PlanService';
import ChangeService from '../../services/ChangeService';
import FullAddressBuilder from '../../common/FullAddressBuilder';
import Configuration from '../../common/Configuration.json';

class Confirm extends React.Component {
  static getConfirmMessage(currentPlanLabel, newPlanLabel, isMove) {
    if (PlanUtilities.isFibreUpgrade(currentPlanLabel, newPlanLabel)) {
      return (
        <div className="default-vertical-padding text-small">
          <div>
            Once you click &quot;Confirm&quot; we&apos;ll kick off the upgrade process. We&apos;ll email you within
            the next 3 business days to let you know what the next steps are.
          </div>
          <div>
            Please note Fibre installs may take a while due to circumstances outside of our control.
          </div>
        </div>
      );
    }
    if (isMove) {
      return (
        <div className="default-vertical-padding text-small">
          <div>
            We will be in touch to confirm the date Skinny broadband will be connected at your new address.
            Don&apos;t forget to pack your Skinny modem as you&apos;ll need it at your new place.
          </div>
        </div>
      );
    }
    return (
      <div className="default-vertical-padding text-small">
        <div>
          Once you click &quot;Confirm&quot; we&apos;ll get onto it. Your speed change should be completed within
          3 business days, and we&apos;ll email a confirmation as soon as it’s done.
        </div>
        <div>
          Please note that occasionally speed changes take longer than 3 days due to circumstances
          outside of our control.
        </div>
      </div>
    );
  }

  static getTitle(isMove) {
    let text = 'Please check the details below & click confirm';
    if (isMove) {
      text = 'Please confirm your move details below.';
    }
    return (
      <div className="col-xs-12 success-header-chosen">{text}</div>
    );
  }

  constructor(props) {
    super(props);
    const isMove = props.params.name === DashboardConstants.MOVE_ADDRESS;
    const newPlanLabel = ChangeService.getNewPlanLabel(
      props.availablePlans,
      props.customerInfo.currentPlan,
      props.selectedPlanId,
      isMove,
      props.speedChangeOption
    );
    this.state = {
      processing: false,
      isMove,
      newPlanLabel
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.hasError = this.hasError.bind(this);
  }

  handleConfirm(event) {
    event.preventDefault();
    const { customerInfo, connectionDate, toAddress } = this.props;
    this.setState({ ...this.state, processing: true });
    this.props.sendChange(
      ChangeService.getChangeRequestPayload(
        customerInfo,
        this.state.newPlanLabel,
        this.state.isMove,
        connectionDate,
        toAddress
      )
    );
  }

  hasError() {
    return this.props.error.status
      && (this.props.error.status.code || this.props.error.status.text);
  }

  render() {
    const {
      customerInfo, toAddress, connectionDate, error, params
    } = this.props;
    return (
      <main>
        <PageHeader title={params.name} />
        <div className="container">
          {Confirm.getTitle(this.state.isMove)}
          {Confirm.getConfirmMessage(customerInfo.currentPlan, this.state.newPlanLabel, this.state.isMove)}
          <div id="from" className="change-confirm-section">
            <h2>From</h2>
            {this.state.isMove &&
            <div>
              <h3>Address</h3>
              <div className="value-div">{FullAddressBuilder.build(customerInfo)}</div>
            </div>
            }
            <h3>Plan</h3>
            <div className="value-div">{customerInfo.currentPlan}</div>
          </div>
          <div id="to" className="change-confirm-section">
            <h2>To</h2>
            {this.state.isMove &&
            <div>
              <h3>Address</h3>
              <div className="value-div">{FullAddressBuilder.build(toAddress)}</div>
            </div>
            }
            <h3>Plan</h3>
            <div className="value-div">{this.state.newPlanLabel}</div>
          </div>
          {this.state.isMove &&
          <div>
            <div id="when" className="change-confirm-section">
              <h2>On</h2>
              <h3>Date</h3>
              <div className="value-div">{connectionDate.toLocaleDateString()}</div>
            </div>
            <div id="warning" className="change-confirm-section">
              <div className="warning">
                Please note: You can move once every 6 months without any admin charges from us.
                If you need to move more than once during a six month period, a
                ${Configuration.moveFee} one-off charge will apply.
              </div>
            </div>
          </div>
          }
          {this.hasError() &&
          <div id="error" className="contact-us-error">
            We are sorry the service is currently unavailable please try again later.<br />
            {error.status.text}
          </div>
          }
          <div className="button-container">
            <Button
              id="change-confirm-confirm"
              onClick={this.handleConfirm}
              disabled={this.state.processing && !this.hasError()}
            >
              {this.state.processing && !this.hasError() ?
                <img
                  src={loader}
                  height="20"
                  alt="Loading..."
                  role="presentation"
                /> : 'Confirm'}
            </Button>
            {this.state.isMove &&
            <Button
              id="change-confirm-back"
              className="btn-secondary"
              onClick={() => browserHistory.replace('/move')}
              disabled={this.state.processing && !this.hasError()}
            >
              Back
            </Button>
            }
            {!this.state.isMove &&
            <Button
              id="change-confirm-back"
              className="btn-secondary"
              onClick={() => browserHistory.replace('/change')}
              disabled={this.state.processing && !this.hasError()}
            >
              Back
            </Button>
            }
          </div>
        </div>
      </main>
    );
  }
}

Confirm.propTypes = {
  params: PropTypes.object,
  toAddress: PropTypes.object,
  connectionDate: PropTypes.instanceOf(Date),
  customerInfo: PropTypes.object,
  availablePlans: PropTypes.arrayOf(PropTypes.object),
  selectedPlanId: PropTypes.number,
  speedChangeOption: PropTypes.string,
  error: PropTypes.object,
  sendChange: PropTypes.func,
};

export default Confirm;



/** WEBPACK FOOTER **
 ** ./src/components/Change/Confirm.js
 **/